import getImagePath from './getImagePath';
import { AffiliationId } from '../CommonSelectors/CommonArea.types';

export const getConsumerLogoUrl = (): string => {
  if (ADV.info.WhiteLabel?.logo) {
    return ADV.settings.endpoints.whitelabelDir + ADV.info.WhiteLabel.logo;
  }

  if (ADV.data.user.AffiliationId === AffiliationId.Alight) {
    return getImagePath('alight-logo.svg');
  }

  return getImagePath('orion-planning-logo.svg');
};
